function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "prefix__a",
  d: "M0 0H18V18H0z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#prefix__a"
})), React.createElement("rect", {
  width: 9.8,
  height: 9.8,
  x: 6.6,
  y: 6.6,
  stroke: "#0082FF",
  strokeWidth: 1.2,
  mask: "url(#prefix__b)",
  rx: 2
}), React.createElement("path", {
  stroke: "#0082FF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M3.808 13.5h-.462c-1.02 0-1.846-.827-1.846-1.846V3.346c0-1.02.827-1.846 1.846-1.846h8.308c1.02 0 1.846.827 1.846 1.846v.462",
  mask: "url(#prefix__b)"
}));

var SvgIcoClone = function SvgIcoClone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoClone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-clone.a15b9194.svg";
export { ForwardRef as ReactComponent };